import React, { useContext, useState } from "react";
import { OperativesContext } from "../providers/OperativesProvider";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";

import "../css/jobDescriptionCard.scss";

function getOps(dbOps = [], ops) {
  ///Returns array of operatives present on job
  if (dbOps.length === 0) return [];
  let opsPresent = [];
  for (let uid in ops) {
    let foundOp = dbOps.find((op) => {
      return op.uid === uid;
    });
    opsPresent.push(foundOp);
  }

  return opsPresent;
}

const JobDescriptionCard = ({ job = null, pickJob, isMarked }) => {
  //   console.log("job", job);
  const [
    materialsDrawer,
    // toggleMaterialsDrawer
  ] = useState(false);
  let dbOperatives = useContext(OperativesContext);
  let {
    // created = "-/-/-",
    jobDate = "-/-/-",
    hours = 0,
    details = "",
    operatives = [],
    // materials = [],
  } = job;

  // console.log("dbOpepratives:", dbOperatives);
  // console.log("whole operatives", operatives);

  let opsPresent = getOps(dbOperatives, operatives);

  let marked = isMarked(job.uid);
  // console.log("marked", marked);

  return (
    <button onClick={() => pickJob(job)} key={job.uid} className="jobCard">
      <div className="jobCardHeader">
        {jobDate && <span>{dateTimeFormatter(jobDate, "d_full")}</span>}
        <span>{hours} hrs</span>
      </div>
      <div className="jobCardBody">
        <p>{details}</p>
      </div>
      <div className="jobCardFooter">
        <div className="opsPresent">
          {opsPresent.map((op, i) => {
            if (!op?.uid) {
              return (
                <span style={{ color: "red" }} key={i}>
                  DELETE
                </span>
              );
            }
            // console.log("ops", opsPresent);
            return <span key={op.uid}>{op.initials}</span>;
          })}
        </div>
        {/* <div onClick={toggleMaterialsDrawer} className="materialsBar">
          <p>
            Materials <span> @</span>
          </p>
        </div> */}
        {materialsDrawer && (
          <div className="materialsSummary">
            <p>A summary will be put here.</p>
          </div>
        )}
      </div>
      {marked && <div className="markedPrimary" />}
    </button>
  );
};

export default JobDescriptionCard;
